module.exports = __webpack_public_path__ + "static/media/ep-program.05a52120.svg";